import { c as _c } from "react/compiler-runtime";
import { FormSelect } from '@systemeio/ui';
import EditActionWrapper from 'modules/automation-rules/actions/components/edit-actions/components/edit-action-wrapper';
import { EditActionItemInterface } from 'modules/automation-rules/actions/components/edit-actions/types/edit-action-item-interface';
import { ActionSpecEmailEditInterface } from 'modules/automation-rules/actions/types/automation-rule-actions-edit-interface';
import CreateEmailModal from 'modules/automation-rules/email/components/create-email-modal';
import EditEmailModal from 'modules/automation-rules/email/components/edit-email-modal';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface ActionSpecEmailItemProps extends EditActionItemInterface<ActionSpecEmailEditInterface> {}
const ActionSpecEmailItem = t0 => {
  const $ = _c(16);
  const {
    actions,
    setRules,
    action,
    onDelete,
    idx,
    errors
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== action.emailMessageWithRecipient.id || $[4] !== action.emailMessageWithRecipient.mailing?.currentEmail.subject || $[5] !== action.id || $[6] !== actions || $[7] !== errors.automationActions || $[8] !== idx || $[9] !== setRules || $[10] !== t) {
    t2 = t3 => {
      const {
        data,
        onOpen,
        renderActionLabel
      } = t3;
      return <FormSelect onOpen={onOpen} placeholder={t("dashboard.automation_rule.choose_email")} label={renderActionLabel({
        label: t("global.email"),
        additionalLabel: <><CreateEmailModal onSetNewEmail={data_0 => {
            onOpen();
            setRules(prev => ({
              ...prev,
              actions: actions.map((el, i) => {
                if (idx === i) {
                  return {
                    ...el,
                    emailMessageWithRecipient: {
                      id: data_0.id,
                      mailing: {
                        currentEmail: {
                          subject: data_0.subject
                        }
                      }
                    }
                  };
                } else {
                  return el;
                }
              })
            }));
          }} mutateSpecificEmailData={data.mutateSpecificEmailData} mutateEmailData={data.mutateEmailData} withRecipient={true} />{action.emailMessageWithRecipient.id && <EditEmailModal mutateEmailData={data.mutateEmailData} withRecipient={true} mutateSpecificEmailData={data.mutateSpecificEmailData} emailId={action.emailMessageWithRecipient.id} />}</>
      })} value={action.emailMessageWithRecipient.id} staticData={getDataFromObj({
        id: action.emailMessageWithRecipient.id,
        name: action.emailMessageWithRecipient.mailing?.currentEmail.subject
      })} data={data.specificEmailData} onChange={data_1 => setRules(prev_0 => ({
        ...prev_0,
        actions: actions.map((el_0, i_0) => {
          if (idx === i_0) {
            return {
              ...el_0,
              emailMessageWithRecipient: {
                id: data_1
              }
            };
          } else {
            return el_0;
          }
        })
      }))} error={errors.automationActions[action.id || idx]?.emailMessageWithRecipient?.join("")} />;
    };
    $[3] = action.emailMessageWithRecipient.id;
    $[4] = action.emailMessageWithRecipient.mailing?.currentEmail.subject;
    $[5] = action.id;
    $[6] = actions;
    $[7] = errors.automationActions;
    $[8] = idx;
    $[9] = setRules;
    $[10] = t;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== action.type || $[13] !== t1 || $[14] !== t2) {
    t3 = <EditActionWrapper slug={action.type} onDelete={t1}>{t2}</EditActionWrapper>;
    $[12] = action.type;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
};
export default ActionSpecEmailItem;